import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'

export type RestrictionsMode = 'tasks' | 'groups'
export type RestrictionsStatus = 'ABIERTAS' | 'CERRADAS'

interface Props {
  mode: RestrictionsMode
  status: RestrictionsStatus
  onChangeMode: (mode: RestrictionsMode) => void
  onChangeStatus: (status: RestrictionsStatus) => void
}

export const RestrictionsViewOptions = ({ mode, status, onChangeMode, onChangeStatus }: Props) => {

  const { t } = useTranslation()

  return (
    <>
      <div className="pl4-tasks-view-menu__label">{t('RESOURCES_RESTRICTIONS:ToolbarTypeLabel')}</div>
      <Dropdown.Item
        as="button"
        className="pl4-tasks-view-menu__item"
        role="menuitemradio"
        aria-checked={mode === 'tasks'}
        onClick={() => onChangeMode('tasks')}
      >
        <span className={`pl4-tasks-view-menu__selection ${mode === 'tasks' ? 'active' : ''}`} aria-hidden="true" />
        <span>{t('RESOURCES_RESTRICTIONS:ToolbarTasksButton')}</span>
      </Dropdown.Item>
      <Dropdown.Item
        as="button"
        className="pl4-tasks-view-menu__item"
        role="menuitemradio"
        aria-checked={mode === 'groups'}
        onClick={() => onChangeMode('groups')}
      >
        <span className={`pl4-tasks-view-menu__selection ${mode === 'groups' ? 'active' : ''}`} aria-hidden="true" />
        <span>{t('RESOURCES_RESTRICTIONS:ToolbarGroupsButton')}</span>
      </Dropdown.Item>

      <Dropdown.Divider />
      <div className="pl4-tasks-view-menu__label">{t('RESOURCES_RESTRICTIONS:ToolbarStatusLabel')}</div>
      <Dropdown.Item
        as="button"
        className="pl4-tasks-view-menu__item"
        role="menuitemradio"
        aria-checked={status === 'ABIERTAS'}
        onClick={() => onChangeStatus('ABIERTAS')}
      >
        <span className={`pl4-tasks-view-menu__selection ${status === 'ABIERTAS' ? 'active' : ''}`} aria-hidden="true" />
        <span>{t('RESOURCES_RESTRICTIONS:ToolbarOpenButton')}</span>
      </Dropdown.Item>
      <Dropdown.Item
        as="button"
        className="pl4-tasks-view-menu__item"
        role="menuitemradio"
        aria-checked={status === 'CERRADAS'}
        onClick={() => onChangeStatus('CERRADAS')}
      >
        <span className={`pl4-tasks-view-menu__selection ${status === 'CERRADAS' ? 'active' : ''}`} aria-hidden="true" />
        <span>{t('RESOURCES_RESTRICTIONS:ToolbarClosedButton')}</span>
      </Dropdown.Item>
    </>
  )
}

const RestrictionsViewMenu = ({ mode, status, onChangeMode, onChangeStatus }: Props) => {

  const { t } = useTranslation()
  const [show, setShow] = useState(false)
  const hasCustomView = mode !== 'tasks' || status !== 'ABIERTAS'

  return (
    <Dropdown
      className="pl4-tasks-view-menu pl4-resources-view-menu"
      show={show}
      onToggle={(nextShow, event, metadata) => {
        if (metadata.source !== 'select') setShow(nextShow)
      }}
    >
      <Dropdown.Toggle
        as="button"
        type="button"
        className={`btn btn-link btn-link-header pl4-resources-action pl4-page-action--secondary ${hasCustomView ? 'active' : ''}`}
        aria-label={t('RESOURCES_RESTRICTIONS:ToolbarViewButton')}
        title={t('RESOURCES_RESTRICTIONS:ToolbarViewButton')}
      >
        <span className="icon-orden_estado" aria-hidden="true" />
        <span className="d-none d-sm-inline">{t('RESOURCES_RESTRICTIONS:ToolbarViewButton')}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu alignRight role="menu" className="pl4-tasks-view-menu__menu">
        <RestrictionsViewOptions
          mode={mode}
          status={status}
          onChangeMode={onChangeMode}
          onChangeStatus={onChangeStatus}
        />
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default RestrictionsViewMenu
